import { createContext, useContext } from "react";

export const PathContext = createContext();

export function usePath() {
  return useContext(PathContext);
}
